// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_contact_body = /** @type {(inputs: {}) => string} */ () => {
	return `Don't hesitate to reach out — we're always happy to help. You can contact us by phone at +357 22 66 06 88 or email us at info@orthohouse.com.cy.`
};

const el_refunds_contact_body = /** @type {(inputs: {}) => string} */ () => {
	return `Μη διστάσετε να επικοινωνήσετε μαζί μας — είμαστε πάντα στη διάθεσή σας. Τηλεφωνήστε μας στο +357 22 66 06 88 ή στείλτε email στο info@orthohouse.com.cy.`
};

const ru_refunds_contact_body = /** @type {(inputs: {}) => string} */ () => {
	return `Не стесняйтесь обращаться к нам — мы всегда рады помочь. Позвоните нам по телефону +357 22 66 06 88 или напишите на info@orthohouse.com.cy.`
};

const he_refunds_contact_body = /** @type {(inputs: {}) => string} */ () => {
	return `אל תהססו לפנות אלינו — תמיד נשמח לעזור. התקשרו אלינו בטלפון +357 22 66 06 88 או שלחו אימייל ל-info@orthohouse.com.cy.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_contact_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_contact_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_contact_body", locale)
	if (locale === "en") return en_refunds_contact_body(inputs)
	if (locale === "el") return el_refunds_contact_body(inputs)
	if (locale === "ru") return ru_refunds_contact_body(inputs)
	if (locale === "he") return he_refunds_contact_body(inputs)
	return "refunds_contact_body"
};